import "core-js/modules/es.array.concat";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { income, income_currency } from "@/api/dataAll/IncomeDetail";
import * as echarts from "echarts";
export default {
  name: "IncomeDetail",
  mixins: [tabulation],
  data: function data() {
    return {
      searchData: {
        start_time: "",
        end_time: ""
      },
      tableData: [],
      cyclicData: [{
        label: this.$t('rechargeAmountIncludeRefund'),
        prop: "recharge_amount"
      }, {
        label: this.$t('refundAmount'),
        prop: "refund_amount"
      }, {
        label: this.$t('revenueAmount'),
        prop: "revenue_amount"
      }],
      cyclicDataVND: [{
        label: this.$t('rechargeAmountIncludeRefund'),
        prop: "recharge_amount"
      }, {
        label: this.$t('rechargeAmountIncludeRefundVnd'),
        prop: "recharge_amountexchange"
      }, {
        label: this.$t('refundAmount'),
        prop: "refund_amount"
      }, {
        label: this.$t('refundAmountVnd'),
        prop: "refund_amountexchange"
      }, {
        label: this.$t('revenueAmount'),
        prop: "revenue_amount"
      }, {
        label: this.$t('revenueAmountVnd'),
        prop: "revenue_amountexchange"
      }],
      cyclicDataUSD: [{
        label: this.$t('rechargeAmountIncludeRefund'),
        prop: "recharge_amount"
      }, {
        label: this.$t('rechargeAmountIncludeRefundUsd'),
        prop: "recharge_amountexchange"
      }, {
        label: this.$t('refundAmount'),
        prop: "refund_amount"
      }, {
        label: this.$t('refundAmountUsd'),
        prop: "refund_amountexchange"
      }, {
        label: this.$t('revenueAmount'),
        prop: "revenue_amount"
      }, {
        label: this.$t('revenueAmountUsd'),
        prop: "revenue_amountexchange"
      }],
      dates: [],
      datas: [],
      series: []
    };
  },
  created: function created() {},
  methods: {
    searchClick: function searchClick() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var reqFn;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // if(this.currencyClose && !this.searchData.currency_info){
                //   this.$message.error('请选择货币类型')
                //   return
                // }
                _this.searchData.start_time = _this.$times.timeStamp(_this.value2[0]);
                _this.searchData.end_time = _this.$times.timeStamp(_this.value2[1]);
                _this.reqLoading = true;
                _context.next = 5;
                return _this.getexchangeRate();

              case 5:
                reqFn = _this.currencyClose ? income_currency : income;
                reqFn(_objectSpread(_objectSpread({}, _this.searchData), _this.defaultData())).then(function (res) {
                  if (res.code == 200) {
                    // res.data = {
                    //   "2023-11-23": {
                    //     "recharge_amount": 1,
                    //     "revenue_amount": 50,
                    //     "refund_amount": 100
                    //   },
                    //   "2023-11-24": {
                    //     "recharge_amount": 0,
                    //     "revenue_amount": 0,
                    //     "refund_amount": 0
                    //   },
                    //   "2023-11-25": {
                    //     "recharge_amount": 0,
                    //     "revenue_amount": 0,
                    //     "refund_amount": 0
                    //   },
                    //   "2023-11-26": {
                    //     "recharge_amount": 0,
                    //     "revenue_amount": 0,
                    //     "refund_amount": 0
                    //   },
                    //   "2023-11-27": {
                    //     "recharge_amount": 0,
                    //     "revenue_amount": 0,
                    //     "refund_amount": 0
                    //   },
                    //   "2023-11-28": {
                    //     "recharge_amount": 0,
                    //     "revenue_amount": 0,
                    //     "refund_amount": 0
                    //   },
                    //   "2023-11-29": {
                    //     "recharge_amount": 0,
                    //     "revenue_amount": 0,
                    //     "refund_amount": 0
                    //   },
                    //   "2023-11-30": {
                    //     "recharge_amount": 0,
                    //     "revenue_amount": 0,
                    //     "refund_amount": 0
                    //   }
                    // }
                    var list = [];

                    for (var k in res.data) {
                      for (var j in res.data[k]) {
                        if (j == "revenue_amount") {
                          res.data[k][j + 'exchange'] = _this.isyjfmvnd() ? (Number(res.data[k][j]) * _this.exchangeRate).toFixed(3) : _this.$utils.conversion(Number(res.data[k][j]) * _this.exchangeRate).toFixed(3);
                          res.data[k][j] = _this.isyjfmvnd() ? res.data[k][j].toFixed(3) : _this.$utils.conversion(res.data[k][j]).toFixed(3);
                        } else {
                          res.data[k][j + 'exchange'] = _this.isyjfmvnd() ? (Number(res.data[k][j]) * _this.exchangeRate).toFixed(2) : _this.$utils.conversion(Number(res.data[k][j]) * _this.exchangeRate).toFixed(2);
                          res.data[k][j] = _this.isyjfmvnd() ? res.data[k][j].toFixed(2) : _this.$utils.conversion(res.data[k][j]).toFixed(2);
                        }
                      }

                      list.push(_objectSpread({
                        date: k
                      }, res.data[k]));
                    }

                    _this.tableData = list;

                    _this.$nextTick(function () {
                      _this.getTableRight();
                    });
                  } // this.getechart()

                }).finally(function () {
                  _this.reqLoading = false;
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getechart: function getechart() {
      var chartDom = document.getElementById("IncomeDetailEchart");
      var myChart = echarts.init(chartDom);
      var option;
      var dates = this.dates;
      var datas = this.datas;
      var series = this.series;
      option = {
        title: {
          text: "ROI"
        },
        animationDuration: 3000,
        tooltip: {
          confine: true,
          trigger: "axis"
        },
        legend: {
          data: dates,
          // 这里显示点击搜索的日期--图表的最上面
          // selected: this.selectedArr,
          width: "80%"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          z: 12,
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          nameLocation: "middle",
          data: datas
        },
        yAxis: {
          type: "value"
        },
        series: series
      };
      option && myChart.setOption(option, true);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchData.page = val;
      this.page = val;
      this.searchClick();
    },
    exportdata: function exportdata() {
      var data = this.tableData;
      var columns = [{
        label: this.$t('date'),
        prop: "date"
      }];

      if (this.queryCurrency == 'VND') {
        columns = [].concat(_toConsumableArray(columns), _toConsumableArray(this.cyclicDataUSD));
      } else if (this.queryCurrency == 'USD') {
        columns = [].concat(_toConsumableArray(columns), _toConsumableArray(this.cyclicData));
      } else {
        columns = [].concat(_toConsumableArray(columns), _toConsumableArray(this.cyclicData));
      }

      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};